<template>
  <div class="first">
    <News></News>
    <div class="right">

      <Maps></Maps>
      <Gonggao></Gonggao>
    </div>

  </div>
</template>

<script>
import News from './First/轮播新闻.vue';
import Maps from './First/乡镇地图.vue';
import Gonggao from './First/公示公告 copy.vue';

export default {
  data() {
    return {}
  },
  components: {
    News,
    Maps,
    Gonggao
  },
  created() {

  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {}
}
</script>

<style scoped>
.first {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  width: 100%;
  /* height: 978px; */
  /* background-color: red; */
}

.right {
  display: flex;
  width: 100%;
  /* height: 978px; */
  flex-flow: row wrap;
  align-content: space-between;
  margin-top: 20px;
}
</style>
